import _ from 'lodash'

/**
 * A trim filter with configurable characters and side (trim, trimStart, trimEnd).
 * Defaults to trim whitespace from both sides.
 *
 * @example
 * {{ ' abc ' | tmrTrim }} => 'abc'
 * {{ ' abc ' | tmrTrim:' ac' }} => 'b'
 * {{ ' abc ' | tmrTrim:' ac':'trimEnd' }} => ' ab'
 *
 * @type {ngFilter}
 */
function tmrTrim() {
  'ngInject'
  const defaultChars = {
    trim: /^\s+|\s+$/g,
    trimStart: /^\s+/,
    trimEnd: /\s+$/,
  }
  return (string, chars, trimFunc = 'trim') => {
    if (Object.keys(defaultChars).indexOf(trimFunc) == -1)
      throw new Error(`Unsupported trim function ${trimFunc} on filter tmrTrim`)
    return _[trimFunc](string, chars ?? defaultChars[trimFunc])
  }
}

export const filter = ['tmrTrim', tmrTrim]
